<!-- Responsibility: Display the reality ledger sidebar.
Scope: View-only list of realities with filtering and selection logic. -->
<reality-ledger-sidebar>
  <aside class="ledger">
    <div class="ledger-header">
      <button class="btn btn-primary" id="btn-initiate" type="button" onclick={ props.onInitiate }>+ Initiate New Reality</button>
    </div>
    <div class="ledger-controls">
      <input
        type="text"
        class="ledger-filter"
        placeholder="Filter ledger..."
        value={ props.ledgerFilter }
        oninput={ props.onFilterInput }
      >
    </div>
    <div class="ledger-scroll">
      <p if={ props.loading } class="panel-message ledger-empty">Loading reality ledger...</p>
      <section if={ !props.loading && !props.isAdmin } class="access-denied">
        <h2>Access denied</h2>
        <p>Manage Realities is available to admin-role holders only.</p>
      </section>
      <ul if={ !props.loading && props.isAdmin } class="ledger-list" id="ledger-list">
        <li each={ offer in props.offers }>
          <button
            type="button"
            class="ledger-item"
            data-active={ props.selectedId === offer.id ? 'true' : 'false' }
            onclick={ () => props.onSelect(offer) }
          >
            <strong>{ offer.title || offer.id }</strong>
            <span>{ offer.summary || 'No summary yet.' }</span>
            <div class="item-meta">
              <span class="item-chip">{ offer.kind }</span>
              <span if={ offer.versionLabel } class="item-chip">{ offer.versionLabel }</span>
              <span class="status-pill" data-status={ offer.publishState === 'published' ? 'Realized' : (offer.publishState === 'retired' ? 'Retired' : 'Draft') }>
                { offer.publishState === 'published' ? 'Realized' : (offer.publishState === 'retired' ? 'Retired' : 'Draft') }
              </span>
            </div>
          </button>
        </li>
      </ul>
      <p if={ !props.loading && props.isAdmin && !props.offers.length } class="panel-copy ledger-empty">No ledger entries match the current filter.</p>
    </div>
  </aside>

  <style>
    .ledger {
      display: grid;
      grid-template-rows: auto auto 1fr;
      background: var(--surface-card);
      border-right: 1px solid var(--border);
      overflow: hidden;
    }
    .ledger-header { padding: var(--space-md); border-bottom: 1px solid var(--border); }
    .ledger-controls { padding: var(--space-sm) var(--space-md); background: var(--bg); }
    .ledger-filter { width: 100%; padding: var(--space-xs); border-radius: 0.25rem; border: 1px solid var(--border); background: var(--surface); color: var(--text); }
    .ledger-scroll { overflow-y: auto; padding: var(--space-sm); }
    .ledger-list { list-style: none; padding: 0; margin: 0; display: grid; gap: var(--space-xs); }
    .ledger-item { width: 100%; text-align: left; background: none; border: 1px solid transparent; border-radius: 0.5rem; padding: var(--space-sm); cursor: pointer; display: grid; gap: 0.25rem; transition: all 0.2s; }
    .ledger-item:hover { background: var(--surface-subtle); }
    .ledger-item[data-active="true"] { background: var(--surface-active); border-color: var(--gold); }
    .ledger-item strong { font-size: 0.9rem; color: var(--text-prose); }
    .ledger-item span { font-size: 0.75rem; color: var(--text-muted); line-height: 1.4; }
    .item-meta { display: flex; flex-wrap: wrap; gap: 0.25rem; margin-top: 0.25rem; }
    .item-chip { background: var(--bg-deep); padding: 0.125rem 0.375rem; border-radius: 0.25rem; font-size: 0.65rem; color: var(--text-muted); text-transform: uppercase; }
    .status-pill { padding: 0.125rem 0.5rem; border-radius: 1rem; font-size: 0.65rem; font-weight: bold; }
    .status-pill[data-status="Realized"] { background: color-mix(in srgb, var(--success) 20%, transparent); color: var(--success); }
    .status-pill[data-status="Draft"] { background: color-mix(in srgb, var(--gold) 20%, transparent); color: var(--gold); }
    .ledger-empty { text-align: center; padding: var(--space-xl); color: var(--text-muted); }
  </style>
</reality-ledger-sidebar>
